module.exports = {};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-polyfill/~/core-js/modules/_iterators.js
 ** module id = 55
 ** module chunks = 0
 **/